// extracted by mini-css-extract-plugin
export default {"about":"About_about__9QFwu","heroRow":"About_heroRow__uZe6j","title":"About_title__zQVAF","lead":"About_lead__75Y67","details":"About_details__RuZHr"};